import React from 'react'
import { createSelector } from 'reselect'
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Avatar } from '@material-ui/core'
import { useSpring, animated } from 'react-spring'
import { Rating } from '@material-ui/lab'

//Components
import Search from '../Search/Search'

//HELPERS
import { replaceStringSpaces } from '../../utils/helpers'

//REDUX
import { makeSelectLogoAnimation } from '../../redux/ducks/signup'

const stateSelector = createSelector(
  [makeSelectLogoAnimation],
  (logoAnimation) => ({ logoAnimation }),
)

const DefaultModel = ({
  name,
  agencyKey,
  logo,
  bannerImage,
  experienceName,
  experienceCategory,
  isMock,
}) => {
  const { logoAnimation } = useSelector(stateSelector)

  const { slug } = useParams()
  const history = useHistory()
  const useStyles = makeStyles((theme) => ({
    bannerBg: {
      backgroundImage: `linear-gradient(0deg, rgba(160, 118, 236, 0.7) 19%, rgba(103, 58, 183, 0.7) 83%), url(${bannerImage})`,
      //  width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: '0% 50%',
      borderRadius: '0 0 25px 25px',
    },
  }))
  const classes = useStyles()

  const { x } = useSpring({
    from: { x: 0 },
    x: logoAnimation ? 1 : 0,
    config: { duration: 300 },
  })

  const handleRedirect = () => {
    const splitUrl = window.location.pathname.split('/')
    let url
    if (splitUrl[1] === 'marketplace') {
      url = `/marketplace/${slug}/${agencyKey}`
    } else {
      url = '/' + splitUrl[1]
    }
    return history.push(url)
    // if (slug) {
    //   return `/marketplace/${slug}/${agencyKey}`
    // } else {
    //   return `/${agencyKey}`
    // }
  }

  return (
    <>
      <Box paddingY={3} m={3} mt={0} className={classes.bannerBg}>
        <Box textAlign="center">
          <animated.div
            style={{
              transform: x
                .to({
                  range: [0, 0.2, 0.4, 0.6, 0.8, 1],
                  output: [0, 20, 0, 20, 0],
                })
                .to((x) => `translate3d(${x}px, 0px, 0px)`),
            }}
          >
            <Avatar
              alt="agency-logo"
              src={logo ? logo : ''}
              style={{ width: '145px', height: '145px', margin: 'auto' }}
            />
          </animated.div>

          <h1
            style={{ cursor: 'pointer', margin: 0, color: 'white' }}
            onClick={() => {
              agencyKey && handleRedirect()
            }}
          >
            {name ? name.replace(/^\w/, (c) => c.toUpperCase()) : ''}
          </h1>
          <h1 style={{ display: 'none' }}>
            {name ? name.replace(/^\w/, (c) => c.toUpperCase()) : ''},
          </h1>
          {experienceName && (
            <h2 style={{ cursor: 'pointer', margin: 0, color: 'white' }}>
              {experienceName}, {experienceCategory}
            </h2>
          )}
        </Box>
      </Box>
    </>
  )
}

export default DefaultModel
